// import { Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
// import React, { useEffect, useState } from 'react'
// import { useHelp } from '../../Hooks/useHelp'
// import { decryptedBody } from '../../Utils/constant';
// import moment from 'moment';
// import VisibilityIcon from '@mui/icons-material/Visibility';

// const UserIssues = () => {

//     const [issues, setIssues] = useState([]);

//     const { getIssues } = useHelp();

//     useEffect(() => {
//         fetchList();
//     }, [])

//     const fetchList = async () => {
//         const issue = await getIssues()
//         if (issue.data.data) {
//             const temp = decryptedBody(issue.data.data)
//             setIssues(temp);
//         }
//     }

//     return (
//         <>
//             <Grid className="product__page">
//                 <TableContainer component={Paper}>
//                     <Table sx={{ minWidth: 650 }} aria-label="simple table">
//                         <TableHead>
//                             <TableRow>
//                                 {['Name', 'Category', 'email', 'Number', 'status', 'Details', 'Ticket Number', 'Raised Date/Time', 'Action'].map((header) => (
//                                     <TableCell key={header} style={{ fontWeight: 'bold' }} align="left">{header}</TableCell>
//                                 ))}
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {issues.map((row) => (
//                                 <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                     <TableCell align="left">{row.name}</TableCell>
//                                     <TableCell align="left">{row.category}</TableCell>
//                                     <TableCell align="left">{row.email}</TableCell>
//                                     <TableCell align="left">{row.number}</TableCell>
//                                     <TableCell align="left">{row.status}</TableCell>
//                                     <TableCell align="left">{row.details}</TableCell>
//                                     <TableCell align="left">{row.ticket_no}</TableCell>
//                                     <TableCell align="left">{moment(row.createdAt).format('LLL')}</TableCell>
//                                     <TableCell align="left">
//                                         <IconButton>
//                                             <VisibilityIcon />
//                                         </IconButton>
//                                     </TableCell>
//                                 </TableRow>
//                             ))}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>
//             </Grid>
//         </>
//     )
// }

// export default UserIssues

import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useHelp } from '../../Hooks/useHelp';
import { decryptedBody } from '../../Utils/constant';
import moment from 'moment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PageHeader from "../../Components/UI/PageHeader";
import SectionCard from "../../Components/UI/SectionCard";

const UserIssues = () => {
  const [issues, setIssues] = useState([]);
  const { getIssues } = useHelp();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = async () => {
    const issue = await getIssues();
    if (issue.data.data) {
      const temp = decryptedBody(issue.data.data);
      setIssues(temp);
    }
  };

  return (
    <Box sx={{ display: "grid", gap: 2 }}>
      <PageHeader
        title="User issues"
        subtitle="Review issues raised by users. (Details action is currently a placeholder.)"
      />

      <SectionCard title="Issues">
        <Box sx={{ overflowX: "auto" }}>
          <TableContainer>
            <Table size={isSmallScreen ? "small" : "medium"} sx={{ minWidth: 900 }}>
              <TableHead>
                <TableRow>
                  {[
                    "Name",
                    "Category",
                    "Email",
                    "Number",
                    "Status",
                    "Details",
                    "Ticket Number",
                    "Raised Date/Time",
                    "Action",
                  ].map((header) => (
                    <TableCell
                      key={header}
                      sx={{ fontWeight: 800, whiteSpace: "nowrap" }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {issues.map((row, index) => (
                  <TableRow key={index} hover>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.category}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.number}</TableCell>
                    <TableCell>{row.status}</TableCell>
                    <TableCell sx={{ maxWidth: 320, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {row.details}
                    </TableCell>
                    <TableCell>{row.ticket_no}</TableCell>
                    <TableCell>{moment(row.createdAt).format("LLL")}</TableCell>
                    <TableCell>
                      <IconButton size="small">
                        <VisibilityIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {issues.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      No issues found.
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </SectionCard>
    </Box>
  );
};

export default UserIssues;
